import * as React from "react";
import {ToastContainer, toast} from "react-toastify";
import {deepEquals} from "../../infrastructure/deep-equals";
import {type UserMessage, UserMessageType} from "./types";
import {showSuccessToast} from "../toast/SuccessToast";
import {showErrorToast} from "../toast/ErrorToast";
import {showInfoToast} from "../toast/InfoToast";

interface MessageProps {
  messages: UserMessage[];
}

export class MessagePanel extends React.PureComponent<MessageProps> {
  public componentDidUpdate(prevProps: MessageProps) {
    const {messages: currentMessages} = prevProps;
    const {messages: pendingMessages = []} = this.props;

    if (deepEquals(currentMessages, pendingMessages) || pendingMessages.length === 0) {
      return;
    }

    pendingMessages.forEach(message => {
      toast.dismiss(message.id);
    });

    pendingMessages
      .filter(m => !currentMessages.map(message => message.message).includes(m.message))
      .forEach(m => {
        if (m.type === UserMessageType.success) {
          showSuccessToast(m);
        }
        if (m.type === UserMessageType.error) {
          showErrorToast(m);
        }
        if (m.type === UserMessageType.info) {
          showInfoToast(m);
        }
      });
  }

  public componentWillUnmount() {
    const {messages = []} = this.props;
    messages.forEach(message => {
      toast.dismiss(message.id);
    });
  }

  public render() {
    return (
      <ToastContainer
        position="top-left"
        style={{zIndex: 2001}}
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        className={"container"}
        toastClassName={"body"}
        closeOnClick
        pauseOnHover
        icon={false}
      />
    );
  }
}
